import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { Soundtrack } from "@/shared/sounds";
import { setActiveApp, setAppsList, setIsShow, setSystemActiveApp } from "@/domains/phone/slice";

export default function useShowPhone(setIsLock: (arg: boolean) => void) {
  const dispatch = useAppDispatch();
  const { play } = useInterfaceSoundCore(Soundtrack.Swipe);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Phone.Show, (state) => {
      dispatch(setIsShow(true));
      dispatch(setAppsList(state.applications));
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Phone.Show);
    };
  }, [dispatch]);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Phone.Hide, () => {
      dispatch(setActiveApp(null));
      dispatch(setSystemActiveApp(null));
      dispatch(setIsShow(false));
      setIsLock(true);
      play();
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Phone.Hide);
    };
  }, [dispatch, play, setIsLock]);
}
